export enum DatabricksAuthTypeEnum {
  OAuthM2M = 'OAuthM2M',
  PersonalAccessToken = 'PersonalAccessToken'
}
